import { ReactElement, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { getComparator, stableSort } from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import { IColumn, IEquipmentLife, Order } from "../../../types";
import TableContainer from "../../../components/tableContainer";

const columns: IColumn[] = [
  {
    id: "equipment",
    label: "Equipment",
    minWidth: 200
  },
  {
    id: "budgetHeats",
    label: "Budget Pieces",
    minWidth: 100,
    align: "right"
  },
  {
    id: "totalUsed",
    label: "Total Used",
    minWidth: 100,
    align: "right"
  },
  {
    id: "currentUsed",
    label: "Current Used",
    minWidth: 100,
    align: "right",
  }
];

interface IProps {
  data: IEquipmentLife[];
}

const EquipmentLifePanel = ({ data }: IProps): ReactElement => {
  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof IEquipmentLife>("equipment");

  const createSortHandler = (property: keyof IEquipmentLife) => () => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <div>
      <TableContainer>
        <Table stickyHeader={true} size={"small"} >
          <TableHead>
            <TableRow>
              {columns.map((column) =>
                <TableCell
                  className="table-header"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, width: column.minWidth }}
                  sortDirection={orderBy === column.id ? order : false}>
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : "asc"}
                    onClick={createSortHandler(column.id as keyof IEquipmentLife)}
                  >
                    {column.label}
                    {orderBy === column.id
                      ? <span className="cell-visuallyHidden">
                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                      </span>
                      : null}
                  </TableSortLabel>
                </TableCell>
              )}
              <TableCell className="table-header"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {stableSort<IEquipmentLife>(data, getComparator(order, orderBy))
              .map((row, index) => {
                return (
                  <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`alarm-row-${index}`}>
                    {columns.map((column: IColumn) => {
                      const value = row[column.id as keyof IEquipmentLife];

                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number" ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                    <TableCell/>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default EquipmentLifePanel;
